import { render, staticRenderFns } from "./page-footer.vue?vue&type=template&id=634dc097&scoped=true&"
import script from "./page-footer.vue?vue&type=script&lang=js&"
export * from "./page-footer.vue?vue&type=script&lang=js&"
import style0 from "./page-footer.vue?vue&type=style&index=0&id=634dc097&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "634dc097",
  null
  
)

export default component.exports